'use client'

import * as React from 'react'
import { useEffect } from 'react'

/**
 * Last-resort boundary for errors thrown in the root layout itself
 * (where the route-level `error.tsx` can't reach). It replaces the
 * whole document, so it must render its own `<html>`/`<body>`. Kept
 * minimal — no app chrome, since the layout that provides it is the
 * thing that failed.
 */
export default function GlobalError({
  error,
  reset,
}: {
  readonly error: Error & { digest?: string }
  readonly reset: () => void
}): React.ReactElement {
  useEffect(() => {
    console.error('Global error boundary caught:', error)
  }, [error])

  return (
    <html lang="en">
      <body
        style={{
          margin: 0,
          minHeight: '100vh',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          background: '#0d0d0d',
          color: '#e5e5e5',
          fontFamily: 'system-ui, sans-serif',
        }}
      >
        <div
          style={{
            maxWidth: 440,
            background: '#141414',
            border: '1px solid #2a2a2a',
            borderRadius: 10,
            padding: 24,
          }}
        >
          <h1 style={{ margin: '0 0 8px', fontSize: 18 }}>Something went wrong</h1>
          <p style={{ color: '#999', fontSize: 14, margin: '0 0 16px' }}>
            The app hit an unexpected error. Reload to recover.
          </p>
          <button
            type="button"
            onClick={() => reset()}
            style={{
              padding: '8px 16px',
              borderRadius: 6,
              border: 'none',
              background: '#4ea1ff',
              color: '#fff',
              fontSize: 14,
              fontWeight: 600,
              cursor: 'pointer',
            }}
          >
            Try again
          </button>
        </div>
      </body>
    </html>
  )
}
